import React from 'react';
import { FilterDropdownProps } from 'antd/es/table/interface';
import TableColumnImg from '../../../../../components/table/TableColumnImg';
import TableColumnTitle from '../../../../../components/_table/TableColumnTitle';
import TableFilterInput from '../../../../../components/_table/TableFilterInput';
import Anchor from '../../../../../components/link/Anchor';
import Tag from '../../../../../components/tag/Tag';
import Button from '../../../../../components/Button';
import { openNewWindow, setDetailPageUrl } from '../../../../../lib/common';
import { TagItem, TagStatus } from '../../types';
import { TAG_STATUS_V2_TEXT } from '../../../../../constants/service/app/tagConstants';
import { TAG_HISTORY_URL_PATH } from '../../../../../constants/service/common/urlConstants';
import OpenPreviewTagDetail from '../../../../../containers/app/common/OpenPreviewTagDetail';

/**
 *  선택된 기획전 아이템 리스트와 기획전 리스트의 공통 컬럼
 */
export const columns = (data: any) => {
  const { filterOption, onFilter, getRelatedTagList } = data;

  return [
    {
      title: <TableColumnTitle title={'이미지'} />,
      dataIndex: 'imageUrl',
      render: (value: string) => <TableColumnImg url={value} width={'60px'} height={'60px'} />,
      width: '80px',
    },
    {
      title: <TableColumnTitle title={'태그 ID'} filterValue={filterOption.id} />,
      dataIndex: 'id',
      filterDropdown: ({ confirm }: FilterDropdownProps) => (
        <TableFilterInput
          type="number"
          placeholder="태그 ID 검색"
          option={filterOption.id}
          confirm={confirm}
          onFilter={(id: number) => onFilter({ id })}
        />
      ),
      render: (value: number) => (
        <Anchor
          color="primary"
          isUnderLine
          text={value}
          onClick={() => openNewWindow(setDetailPageUrl(TAG_HISTORY_URL_PATH, value))}
        />
      ),
      width: '100px',
    },
    {
      title: <TableColumnTitle title={'태그명'} filterValue={filterOption.name} />,
      dataIndex: 'name',
      filterDropdown: ({ confirm }: FilterDropdownProps) => (
        <TableFilterInput
          placeholder={'태그명 검색'}
          option={filterOption.name}
          confirm={confirm}
          onFilter={(name: string) => onFilter({ name })}
        />
      ),
      render: (value: string, record: TagItem) => <OpenPreviewTagDetail text={value} tagId={record.id} />,
      width: '150px',
    },
    {
      title: <TableColumnTitle title={'태그 상태'} />,
      dataIndex: 'status',
      render: (value: TagStatus) => TAG_STATUS_V2_TEXT[value],
      width: '100px',
    },
    {
      title: <TableColumnTitle title={'태그 그룹'} />,
      dataIndex: 'tagGroupList',
      render: (value: string[]) =>
        value.length > 0 ? value.map((tagName, index) => <Tag key={index} text={tagName} isAddHash={false} />) : '-',
    },
    {
      title: <TableColumnTitle title={'연관된 태그'} />,
      dataIndex: 'viewTag',
      render: (value: number, record: TagItem) => (
        <Button isRadius color="primary" text="태그 보기" onClick={() => getRelatedTagList({ tagId: record.id })} />
      ),
      width: '150px',
    },
    {
      title: <TableColumnTitle title={'생성일'} />,
      dataIndex: 'createDate',
      width: '170px',
    },
  ];
};
